<template>
    <div class="moderation page-container">
        <PageContent :content="this.content"></PageContent>

    </div>
</template>
<script>
    import coaching from '../content/coaching.json'
    import PageContent from "../components/PageContent";


    export default {
        components: {PageContent},
        metaInfo() {
            return {
                title: this.page.title,
                titleTemplate: "%s | DrThumm GmbH",
                meta: [
                    { name: 'description', content: this.page.metaDescription }
                ]
            }
        },
        data() {
            return {
                content: {
                    coaching
                }
            }
        },
        computed: {
            page() {
                this.showImage = false
                let route = this.$route.fullPath
                let routes = route.split('/')
                var filtered = routes.filter(el => el != "" )

                let content = this.content
                console.log(content.moderation)
                filtered.forEach(r => {
                    if (filtered.length === 1) content = content[r][r]
                    else content = content[r]
                })
                return content
            }

        },
        updated() {
            this.showImage = true
        },
        beforeCreate() {
            document.body.className = ""
        }
    }
</script>
<style lang="sass">

</style>